import { ca } from '@cian/analytics';

export const trackMyHomeWithoutEstimationShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHome',
    action: 'Show',
    label: 'NoEstimationBanner',
  });
};
